/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import {makeStyles} from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import React from 'react';

export interface TooltipVProps {
  tooltipStyle?: object;
  arrowStyle?: object;
  arrow?: boolean;
  children: any; //Needs to be able to hold a ref.
  disableFocusListener?: boolean;
  disableHoverListener?: boolean;
  disableTouchListener?: boolean;
  enterDelay?: number;
  enterNextDelay?: number;
  enterTouchDelay?: number;
  id?: string;
  interactive?: boolean;
  leaveDelay?: number;
  leaveTouchDelay?: number;
  onClose?(event: object): void;
  onOpen?(event: object): void;
  open?: boolean;
  renderItem?(item: object, index: number): void;
  placement?:
    | 'bottom-end'
    | 'bottom-start'
    | 'bottom'
    | 'left-end'
    | 'left-start'
    | 'left'
    | 'right-end'
    | 'right-start'
    | 'right'
    | 'top-end'
    | 'top-start'
    | 'top';
  PopperComponent?: any;
  PopperProps?: object;
  title: string | boolean | number;
  TransitionComponent?: any;
  TransitionProps?: any;
}

const useStyles = makeStyles({
  tooltip: (style: any) => ({
    ...style?.tooltipStyle,
  }),
  arrow: (style: any) => ({
    ...style?.arrowStyle,
  }),
});

export const TooltipV = ({
  tooltipStyle,
  arrowStyle,
  arrow,
  children,
  disableFocusListener,
  disableHoverListener,
  disableTouchListener,
  enterDelay,
  enterNextDelay,
  enterTouchDelay,
  id,
  interactive,
  onClose,
  onOpen,
  leaveDelay,
  leaveTouchDelay,
  open,
  placement,
  PopperComponent,
  PopperProps,
  title,
  TransitionComponent,
  TransitionProps,
  renderItem,
}: TooltipVProps) => {
  const classes = useStyles({tooltipStyle, arrowStyle});

  const CustomComponent = React.forwardRef(function CustomComponent(
    props,
    ref,
  ) {
    //  Spread the props to the underlying DOM element.
    return (
      <div {...props} ref={ref}>
        {children &&
          children.map(
            (child: object, index: number) =>
              renderItem && renderItem(child, index),
          )}
      </div>
    );
  });
  return (
    <Tooltip
      arrow={arrow}
      disableFocusListener={disableFocusListener}
      disableHoverListener={disableHoverListener}
      disableTouchListener={disableTouchListener}
      enterDelay={enterDelay}
      enterTouchDelay={enterTouchDelay}
      enterNextDelay={enterNextDelay}
      id={id}
      interactive={interactive}
      onClose={onClose}
      onOpen={onOpen}
      leaveDelay={leaveDelay}
      leaveTouchDelay={leaveTouchDelay}
      open={open}
      placement={placement}
      PopperComponent={PopperComponent}
      PopperProps={PopperProps}
      title={title}
      TransitionComponent={TransitionComponent}
      TransitionProps={TransitionProps}
      classes={{tooltip: classes.tooltip, arrow: classes.arrow}}
    >
      <CustomComponent />
    </Tooltip>
  );
};